import homeConfig from "./module-message-config/homeMessageConfig.json";
import inventoryConfig from "./module-message-config/inventoryMessageConfig.json";
import manageDeviceConfig from "./module-message-config/manageDevicesMessageConfig.json";
import patchConfig from "./module-message-config/patchMessageConfig.json";
import alertsConfig from "./module-message-config/alertsMessageConfig.json";
import remoteConfig from "./module-message-config/remoteMessageConfig.json";
import reportsConfig from "./module-message-config/reportsMessageConfig.json";
import enrollmentConfig from "./module-message-config/enrollmentMessageConfig.json";
import settingsConfig from "./module-message-config/settingsMessageConfig.json";

const subModuleKeys = {
  inventory: [
    "INVENTORY_OVERVIEW",
    "INVENTORY_DEVICES",
    "INVENTORY_SOFTWARE",
    "INVENTORY_HARDWARE",
    "GEO_LOCATION",
    "SOFTWARE_LICENSE",
    "APPLICATION_CONTROL",
    "SOFTWARE_METERING",
    "SCAN_DEVICE",
    "SCHEDULE_SCAN",
    "SCAN_SETTINGS",
    "SOFTWARE_CATEGORY",
    "GEO_LOCATION_SETTINGS",
  ],
  manage: [
    "MANAGE_DEVICES_AND_GROUPS",
    "CONFIGURATION_PROFILES",
    "DEPLOYMENT_PROFILES",
    "SOFTWARE_DEPLOYMENT",
    "SCRIPTS",
    "MANAGE_DEVICES_AND_GROUPS_OVERVIEW",
  ],
  patch: [
    "MISSING_PATCHES",
    "INSTALLED_PATCHES",
    "ALL_PATCHES",
    "VULNERABILITIES",
    "CVE_DETAILS",
    "SCAN_DEVICES_PATCH",
    "GROUP_DEVICE_PROFILE_OVERVIEW",
    "SCAN_SYSTEM",
    "MANUAL_DEPLOYMENT",
  ],
  remote: [
    "REMOTE_CONTROL",
    "REMOTE_SUPPORT",
    "WAKE_ON_LAN",
    "SHUTDOWN",
    "USER_CONFIRMATION",
    "PREFERENCES",
    "RECORDING",
    "CONFIGURE_WOL",
  ],
  alerts: ["ALERTS_GENERATED", "ALERT_POLICY", "ALERT_ASSOCIATE_POLICY"],
  enrollment: [
    "DEPLOYMENT",
    "ENROLLED_DEVICES",
    "UNMANAGED_DEVICES",
    "DOMAIN",
    "CONNECTOR",
    "BULK_DEPLOYMENT_GPO",
    "BULK_DEPLOYMENT_INTUNE",
    "BULK_DEPLOYMENT_SCCM",
    "BULK_DEPLOYMENT_AZURE",
  ],
  settingsEnrollment: [
    "DEPLOYMENT",
    "DOMAIN",
    "CONNECTOR",
    "BULK_DEPLOYMENT_AZURE",
    "BULK_DEPLOYMENT_GPO",
    "BULK_DEPLOYMENT_INTUNE",
    "BULK_DEPLOYMENT_SCCM",
  ],
  settings: [
    "CUSTOMERS",
    "USER_MANAGEMENT",
    "ROLE",
    "GROUPS",
    "REBRANDING",
    "CREDENTIAL_MANAGER",
    "ACTIVITY",
    "TWO_FA_SETTINGS",
    "IP_RESTRICTION",
    "SESSION_SETTINGS",
    "AGENT_PROTECTION",
    "DATA_CLEANUP_SETTINGS",
    "SCHEDULE_SCAN",
    "SOFTWARE_CATEGORY",
    "SCAN_SETTINGS",
    "GEO_LOCATION",
    "CONFIGURE_WOL",
    "USER_CONFIRMATION",
    "PERSONALIZATION",
    "SUBSCRIPTIONS",
    "OFFERS",
  ],
};

export const messageConfig = [
  {
    id: "agent-not-installed",
    scope: ["*"],
    excludeScope: [
      ...subModuleKeys["enrollment"],
      ...subModuleKeys["settingsEnrollment"],
      "REBRANDING",
      "PERSONALIZATION",
      "SUBSCRIPTIONS",
      "OFFERS",
    ],
    condition: "HAS_NO_AGENT",
    status: "warning",
    priority: 9999,
    title: "Download Agent",
    component: "AgentDownloadAlert",
    dismissible: false,
  },
  ...homeConfig,
  ...inventoryConfig,
  ...manageDeviceConfig,
  ...patchConfig,
  ...alertsConfig,
  ...remoteConfig,
  ...reportsConfig,
  ...enrollmentConfig,
  ...settingsConfig,
];
